<template>
  <NuxtLayout>
    <WizPage v-if="page" :blok="page.content" :url-path="page.full_slug" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import type { ISbStoryData } from 'storyblok-js-client'
import type { WizPageBlok } from '~/types/storyblok'
import { isOpenInStoryblok } from '~/utils/storyblok'

const story = useStoryData()
const { storyData } = storeToRefs(story)
const { relativePath, storyblok } = await usePageConfig()

const page = await useStoryblokPage<WizPageBlok>(join(storyblok.pagesPath, relativePath), !isOpenInStoryblok())
if (page?.id) {
  provide('isWizcoAvailable', page?.content?.ContentBlocks?.some((blok) => blok.component === 'WPBlockWizco'))
  onMounted(() => {
    useStoryblokBridge(page?.id, (newStory) => {
      storyData.value = newStory as ISbStoryData<WizPageBlok>
    }, {
      resolveRelations: 'overview.featured_story',
      resolveLinks: 'url',
      preventClicks: true,
    })
  })
}

if (!page) {
  showError({
    statusCode: 404,
    message:
      'Es tut uns leid, aber die Seite, die Sie suchen, konnte leider nicht angezeigt werden.',
    statusMessage: 'Fehler - Es ist ein technisches Problem aufgetreten.',
  })
} else {
  await clearError()
}

storyData.value = page
</script>
